var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-section',[_c('integration-promotions-table',{attrs:{"integration-id":_vm.model.id,"integration-type":_vm.model.type,"sync-enabled":_vm.model.params.sync_enabled,"sync-advanced":_vm.model.params.sync_advanced,"sync-disabled":_vm.syncDisabled}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5df5b54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/integrations/types/dynamicpromotions/DynamicPromotions.vue
// module id = null
// module chunks = 